<template>
    <div class="layui-side " id="app-left-nav">
        <div class="layui-side-scroll">
            <div class="layui-logo">
                <span>神二科技服务平台</span>
            </div>
            <ul class="layui-nav layui-nav-tree layui-inline" style="margin-bottom: 30px;background: rgb(247, 247, 247)!important;">
                <li class="layui-nav-item" v-for="(menu, index) in subMenu" :key="menu.id" :index='menu.id'
                :class="{'layui-nav-itemed': menu.id == $store.state.menu.activeItem}" 
                :id='"nav-item-" + menu.id' >
                    <a href="javascript:;" 
	                class="ahover"
                    @click="controlNavItem(menu.id, index)"
                    @mouseover="itemMouseOver($event, menu.id)"
                    @mouseout="itemMouseOut($event, menu.id)"
					style="color: #333;display: flex;align-items: center;"
                    :style="{'background':menu.id == $store.state.menu.activeItem?'#fff':'#f7f7f7','color':menu.id == $store.state.menu.activeItem?'#306aee!important':'#333','border-top':index===0?'1px solid #fff':'none'}"
                    > 
                        <svg class="se-icon" 
						:style="{'background':menu.id == $store.state.menu.activeItem?'rgb(48, 106, 238)':'#333'}">
                            <use :xlink:href="menu.icon"></use>
                        </svg> 
                        <cite>{{menu.name}}</cite> 
						<i :class="[menu.id == $store.state.menu.activeItem?'el-icon-arrow-up':'el-icon-arrow-down']" style="margin-left: auto;"></i>
                        <!-- <span 
						 class="layui-nav-more" style="border-top-color: #333;"></span> -->
                    </a>

                    <dl class="layui-nav-child active-dl" :id='"dl-" + menu.id' 
                    :style="{'height':  menu.id == $store.state.menu.activeItem? 50*itemMenu(menu.id,null).length+'px' : '0'}">
                        <dd v-for="item in itemMenu(menu.id,null)" 
						:style="{'background':item.index == $store.state.menu.activeSubItem?'#fff':'#f7f7f7'}"
						style="height: 50px;"
                            :key="item.index" :index="item.index" >
                            <a href="javascript:;"
							class="ahover"
							style="color: #333;height: 50px;line-height: 50px;padding-left: 50px;"
                            :id="item.path.split('/')[1] + 'Menu'"
                            @click="controlSubItem(menu.id, item.index)"
                            :style="{'background':item.index == $store.state.menu.activeSubItem?'#fff':'#f7f7f7'}"
                            >
							{{item.name}}
							</a>
                        </dd>
                    </dl>

                </li>
                <span class="layui-nav-bar" @mouseover="itemMouseOver($event, menu.id)"
                :style="{ top: barTop + 'px', height: barHeight + 'px', opacity: barOpacity}"></span>
            </ul>

        </div>
    </div>


</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
    data(){
        return {
            barTop: 0,
            barHeight: 0,
            barOpacity: 0,
        }
    },



    mounted() {
        this.getMenu();
    },

    methods: {
        ...mapActions("menu", {
          getMenu: "getMenu",
          clickMenuItem: "clickMenuItem"
        }),

        //一级菜单  
        controlNavItem(id, index){
            //若当前一级菜单是展开的，再次点击则收起
            if(this.$store.state.menu.activeItem == id){
                this.$store.commit('menu/setActiveItem', '0');
            }
            //否则展开
            else{
                this.$store.commit('menu/setActiveItem', id);
            }

            this.barTop = 61*index;
            this.barHeight = 61;
            this.barOpacity = 1;


            let w = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

            let h = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
            
            if(w < this.$store.state.style.smallViewportSize){
               //To do
            }else{
                this.$store.commit('style/setSideShrink', false);
            }

        },

        //二级菜单
        controlSubItem(menuId, index){
            this.$store.commit('menu/setActiveItem', menuId);

            //打开相关页面
            this.clickMenuItem(index);
        },
        

        itemMouseOver(e, id){
            if(id){
                this.barTop = document.getElementById('nav-item-'+id).offsetTop;
            }
            this.barHeight = 61;
            this.barOpacity = 1;
        },

        itemMouseOut(e, id){
            this.barHeight = 0;
            this.barOpacity = 0;
            this.barTop = document.getElementById('nav-item-'+id).offsetTop;
        },

    },

    computed: {
        ...mapState("menu", {
          menu: "menu",
          activeSubItem: "activeSubItem",
        }),
        ...mapGetters("menu", {
          subMenu: "subMenu",
          groupMenu: "groupMenu",
          itemMenu: "itemMenu"
        })
    }
};
</script>

<style lang="less" scoped>
.navmore02{
	border-color:transparent transparent #333;
}
.navmore01{
	border-color:transparent transparent rgb(48, 106, 238) !important;
}
.ahover:hover{
	background: #fff!important;
	border-left-color: #fff!important;
}
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.layadmin-tabspage-none{
    *{
        transition: all .3s;
    }
}

#app-left-nav{
    top: 0;
    z-index: 1002;
    transition: all .3s;



    .layui-side-scroll{
        background: #f7f7f7 !important;

        .layui-nav-bar:hover{
            height: 61px;
        }
    }

    .layui-nav{
        margin-top: 60px;
    }

    .layui-nav .layui-nav-child a {
        padding: 0 0 0 40px;
    }

    .layui-nav-tree .layui-nav-item >a {
        padding-top: 8px;
        padding-bottom: 8px;
        height: 61px;

        svg{
            margin-right: 5px;
        }
    }


    .layui-logo{
        position: fixed;
        z-index:1002;

        height: 60px;
        padding: 0 15px;
        overflow: hidden;
        background: #35353d!important;
        span{
            font-size: 18px;
            color: #fff;
			
        }

    }


    .layui-nav-item .active-dl{
        display: block;
        overflow: hidden;
        transition: .3s;
    }

}


.layadmin-view-xs.layadmin-side-shrink{
    *{
        transition: all .3s;
    }

    #app-left-nav{
        width: 45px;


        .layui-nav-tree .layui-nav-item >a {
            svg{
                margin-right: 35px;
            }
        }

        .layui-logo{
            width: 45px;
            background-repeat: no-repeat;
            background-position: center center;
        }

    }

}

.layadmin-view-sm.layadmin-side-shrink{
    #app-left-nav{
        width: 0;
        .layui-logo{
            width: 0;
            padding: 0;
        }
    }
}

</style>
